export default "__VITE_ASSET__B$P21dp1__"